export default __webpack_public_path__ + "static/media/logOut.a0ebc435.svg";